/**
 * http配置
 */
import axios from 'axios'
import Config from './config/config'
import store from './store'
// import router from './router'
// import Datetime from './util/datetime'
import { Toast } from 'vant'

// axios 配置
axios.defaults.timeout = 50000
axios.defaults.baseURL = Config.apiBaseUrl
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers['Content-Type'] = 'application/json'
axios.defaults.withCredentials = true

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // Toast.loading({ message: '加载中,请稍后' })
    console.log(config.url)
    if (store.state.token && config.url.indexOf('http') === -1) {
      config.headers.common['x-user-token'] = store.state.token
    }
    return config
  },
  err => {
    // Toast.clear()
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // Toast.clear()
    return response.data
  },
  error => {
    // Toast.clear()
    console.log(error)
    // const errMsg = error.toString()
    // console.log(errMsg)
    // const code = errMsg.substr(errMsg.indexOf('code') + 5)
    // // 如果token过期，则重新获取token
    // if (code === '401') {
    //   var redirect_uri = util.removeUrlParam(window.location.href, 'code')
    //   var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Config.appId + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=0#wechat_redirect'
    //   window.location.href = auth_url
    // }
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http.js